// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1hwyR","icon-wrapper":"_2AfF4"};